import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React from 'react';
import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';
import { httpBodyOptions } from '../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../CommonUtils/urlWithParams';
import { LEFT } from '../MultiWorkflows/Input/InputView';
import AutoComplete from '../MultiWorkflows/InputAutocomplete/InputAutocompleteView';

class SchoolSearchInput extends React.Component {
  constructor(props) {
    super(props);

    const { debounceDuration, value } = props;

    this.state = {
      isFetching: false,
      schoolSuggestions: [],
      schoolName: value || '',
    };

    const debouncedFetch = debounce(
      this.fetchSchoolSuggestions.bind(this),
      debounceDuration || 500,
    );

    this.fetchSchoolSuggestionsDebounced = term =>
      this.setState({ schoolSuggestions: [], isFetching: true }, debouncedFetch.bind(this, term));
  }

  async fetchSchoolSuggestions(term) {
    try {
      const { clientId } = this.props;

      const response = await fetchWithDefaults(
        urlWithParams('/Consumer/AutoComplete/ListSchoolsLegacy', { clientId }),
        { method: 'POST', ...httpBodyOptions({ term }) },
      );

      const { success, errors, payload } = await response.json();

      if (success) {
        const { Data: schoolSuggestions } = payload.viewData;

        this.setState({ schoolSuggestions });
      } else {
        console.error(errors);
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ isFetching: false });
    }
  }

  updateSelectedSchool(schoolName) {
    this.setState({ schoolName });

    const { onChange } = this.props;
    const { schoolSuggestions } = this.state;

    const selectedSchool = schoolSuggestions.find(({ Name }) => schoolName === Name);

    onChange(selectedSchool || schoolName);
  }

  render() {
    const { className, inputWrapperClassName, placeholder, htmlPlaceholder, id } = this.props;

    const { schoolSuggestions, schoolName, isFetching } = this.state;

    return (
      <AutoComplete
        className={`school-search ${className}`}
        inputWrapperClass={`${isFetching ? 'schools-loading' : ''} ${inputWrapperClassName}`}
        options={schoolSuggestions}
        fetchOptions={this.fetchSchoolSuggestionsDebounced}
        getOptionValue={({ Name: CollegeName }) => CollegeName}
        getOptionKey={({ Id }) => Id}
        renderOption={({ Name: CollegeName, State }) => (
          <div className="school">
            <div className="school-name">{CollegeName}</div>
            <div className="school-state">{State}</div>
          </div>
        )}
        showEmptyCustomMessage={!isFetching}
        customEmptyMessage="School not found"
        value={schoolName}
        onChange={({ target: { value } }) => this.updateSelectedSchool(value)}
        placeholder={placeholder}
        isUnder
        alignment={LEFT}
        htmlPlaceholder={htmlPlaceholder}
        id={id}
      />
    );
  }
}

SchoolSearchInput.defaultProps = {
  debounceDuration: 500,
  onChange: () => {},
  value: '',
  className: '',
  inputWrapperClassName: '',
  placeholder: '',
  htmlPlaceholder: null,
};

SchoolSearchInput.propTypes = {
  debounceDuration: PropTypes.number,
  clientId: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  inputWrapperClassName: PropTypes.string,
  placeholder: PropTypes.string,
  htmlPlaceholder: PropTypes.string,
};

export default SchoolSearchInput;
